export default {
  baseUrl: process.env.REACT_APP_STORE_API,
  storeKey: process.env.REACT_APP_STORE_KEY,
  adsoftKey: process.env.REACT_APP_ADSOFT_KEY
}